import React from 'react';
import AppContainer from '../app-container';
import * as postActions from '../../actions/post';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PostsList from '../../components/post/posts-list';
import Paginator from '../../components/paginator';
import LocalizedStrings from '../../localization/strings';
import Loading from '../../components/loading';
import DocumentTitle from 'react-document-title';

class PostsPageContainer extends AppContainer {

    componentWillMount() {
        let page = 0;
        if (this.props.params.page) {
            page = this.props.params.page;
        }
        this.props.actions.fetchPostsPaginated(page, 10);
    }
    loadItems(props) {
        let page = 0;
        if (props.params.page) {
            page = props.params.page;
        }
        this.props.actions.fetchPostsPaginated(page, 10);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.params.page !== this.props.params.page) {
            this.loadItems(nextProps);
        }
    }

    renderPosts(posts) {
        return <div>
            <PostsList posts={posts.items}></PostsList>
            <Paginator totalPages={posts.total_pages} currentPage={posts.page} baseUrl="/posts"></Paginator>
        </div>
    }

    render() {
        const {posts} = this.props;
        return (
            <DocumentTitle title={this.getDocumentTitle(LocalizedStrings.news)}>

                <div className="page-section">
                    <div className="container">
                        <h3 className="title">
                            <span>{LocalizedStrings.news}
                            </span>
                        </h3>
                        {posts.loading
                            ? <Loading/>
                            : this.renderPosts(posts)}
                    </div>
                </div>
            </DocumentTitle>
        )
    }
}
export default connect(function(state) {
    return {posts: state.post.posts};
}, function(dispatch) {
    return {
        actions: bindActionCreators({
            ...postActions
        }, dispatch)
    };
})(PostsPageContainer);



// WEBPACK FOOTER //
// ./src/js/containers/pages/posts-page-container.js